import { Badge, Button, ButtonGroup, DialogBody, DialogFooter, Stack, Table, Text } from "@chakra-ui/react"
import { UI } from "components"
import useOrder from "hooks/useOrder";
import moment from "moment";

export default function History({ data = {}, ...props }){

    const order = useOrder(data?.id)
    const columns = [{ children: 'Data' }, { children: 'Descrição' }]

    return(
    <UI.Dialog size="sm" title={`Histórico do pedido #${order.data?.cod}`} {...props}>
        <DialogBody>
            <UI.Table columns={columns} data={order.data?.history} Row={Row} />
        </DialogBody>
        <DialogFooter>
            <ButtonGroup>
                <Button variant="ghost" onClick={props.onClose}>Fechar</Button>
            </ButtonGroup>
        </DialogFooter>
    </UI.Dialog>
    )    
}

const Row = ({ data }) => { 

    return(
    <Table.Row>
        <Table.Cell fontSize="xs">{moment(data?.created_at).format('LLL')}</Table.Cell>
        <Table.Cell><Badge fontSize="sm" children={data?.label} /></Table.Cell>
    </Table.Row>
    )
}